import { render, staticRenderFns } from "./SelectDepartWidget.vue?vue&type=template&id=1067a386&"
import script from "./SelectDepartWidget.vue?vue&type=script&lang=js&"
export * from "./SelectDepartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports